/** @format */

import { combineReducers } from "redux";
import { reducerAuth } from "./reducerAuth";

export const reducers = combineReducers({
  auth: reducerAuth,
});
